import React from "react";
import { connect } from "react-redux";
import { Link, browserHistory } from "react-router";
import ReactTable from "react-table";
import fileDownload from "js-file-download";
import MaskDecimal from "../../components/Util/MaskDecimal";
import MaskDate from "../../components/Util/MaskDate";
import { toastr } from "react-redux-toastr";

import Title from "../../components/Layout/Title";
import { INVOICE_DETAIL_INVOICES_LOAD, INVOICE_DETAIL_CHARGING_LOAD, INVOICE_ANEXOS_LIST_LOAD, LOGOUT, CONFIRM_ACTION_OPEN } from "../../actions/Constants";
import api from "../../api/apiUtil";

import Dropzone from "react-dropzone";
import _ from "lodash";
import { BeatLoader } from "react-spinners";

import jsPDF from "jspdf";
import "jspdf-autotable";
import barcodeImage from "../../img/bar-code.png";

const columns = [
  {
    Header: "Razão Social",
    accessor: "razaoSocial",
    className: "align-middle text-center",
    headerClassName: "font-extra-bold",
    show: "delegaPara" === null || undefined ? true : false,
  },
  {
    Header: "Nº Registro",
    accessor: "numRegistro",
    className: "align-middle text-center",
    headerClassName: "font-extra-bold",
  },
  {
    Header: "Contrato",
    accessor: "numero",
    className: "align-middle text-center",
    headerClassName: "font-extra-bold",
  },
  {
    Header: "Veículo",
    accessor: "chassi",
    className: "align-middle text-center",
    headerClassName: "font-extra-bold",
    /*Cell: row => (
    <div>
      <small>Placa: {row.original.ufPlaca} - {row.original.numPlaca}</small><br/>
      <small>Renavam: {row.original.renavam}</small><br/>
      <small>Chassi: {row.original.chassi}</small><br/>
    </div>
      )*/
  },
  {
    Header: "Operação",
    accessor: "tipo",
    className: "align-middle text-center",
    headerClassName: "font-extra-bold",
  },
  {
    Header: "Data Registro", // Custom header components!
    className: "align-middle text-center",
    headerClassName: "font-extra-bold",
    accessor: "data",
    Cell: (row) => <div>{MaskDate.TO_BR(row.original.dataProcessamento)}</div>,
  },
];

class InvoiceDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      paramsUpload: false,
    };
  }

  componentDidMount() {
    this.props.onListLoad(api.Charging.registrosFaturamento(this.props.params.slug));
    Promise.resolve(api.Charging.get(this.props.params.slug)).then((res) => {
      this.props.onChargingsLoad(res);
      Promise.resolve(api.Charging.getTiposAnexo(this.props.params.slug)).then((resp) => {
        this.props.onListAnexos(resp);
        this.verificaParamsUf();
      });
    });
  }

  handleClickDownload = (tipo) => (ev) => {
    ev.preventDefault();
    var props = this.props;
    Promise.resolve(api.Charging.getAnexoCobranca(this.props.params.slug, tipo))
      .then((response) => {
        fileDownload(response.body, response.headers["filename"], response.type);
      })
      .catch((e) => {
        if (e.message === "Unauthorized" || e.message === "jwt expired") {
          api.Auth.logout();
          props.onLogout();
        } else {
          toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
        }
      });
  };

  handleClickUpload = (filesToUpload, tipo) => {
    var types = ["application/pdf"];
    var alerta = "É permitido anexar somente PDF.";
    if (tipo == "RELATORIO" || tipo == "RELATORIO2") {
      types.push("application/vnd.ms-excel");
      types.push("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
      alerta = "É permitido anexar somente PDF ou arquivos Excel.";
    }
    if (!filesToUpload[0] || types.indexOf(filesToUpload[0].type) < 0) {
      toastr.info("Atenção", alerta);
    } else {
      toastr.info("Aguarde", "Processando arquivo...", {
        timeOut: 0,
        component: () => {
          return <BeatLoader size={15} margin={2} color={"#58abc3"} loading={true} />;
        },
      });
      var props = this.props;
      var idCobranca = this.props.params.slug;
      Promise.resolve(api.Charging.sendAnexoCobranca(idCobranca, tipo, filesToUpload[0]))
        .then((response) => {
          Promise.resolve(api.Charging.getTiposAnexo(this.props.params.slug)).then((resp) => {
            this.props.onListAnexos(resp);
            this.verificaParamsUf();
          });
          toastr.removeByType("info");
          toastr.success("Sucesso", "Documento enviado.");
        })
        .catch(function (resp) {
          if (resp.message === "Unauthorized" || resp.message === "jwt expired") {
            api.Auth.logout();
            props.onLogout();
          } else {
            toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
          }
        });
    }
  };

  verificaParamsUf = () => {
    if (this.props.fatura && this.props.fatura.paramsUf && this.props.fatura.paramsUf.lista2) {
      let contem = true;
      for (const value of this.props.fatura.paramsUf.lista2) {
        if (!this.props.tipoAnexos.filter((a) => a.tipo === value).length > 0) {
          contem = false;
        }
      }
      this.setState({ paramsUpload: contem });
    }
  };

  handleClickClose = () => (ev) => {
    this.props.onActionOpen({
      description: `Confirma o fechamento da cobrança?`,
      onSuccess: this.handleOnClose.bind(this),
    });
  };

  handleOnClose() {
    var props = this.props;
    var dados = {
      idCobranca: this.props.params.slug,
    };
    Promise.resolve(api.Charging.fechaCobranca(dados))
      .then((response) => {
        toastr.success("Sucesso", "Faturamento fechado com sucesso");
        this.props.onListLoad(api.Charging.registrosFaturamento(dados.idCobranca));
        this.props.onChargingsLoad(api.Charging.get(dados.idCobranca));
      })
      .catch((e) => {
        if (e.message === "Unauthorized" || e.message === "jwt expired") {
          api.Auth.logout();
          props.onLogout();
        } else if (e.response && e.response.text) {
          toastr.info("Aviso", JSON.parse(e.response.text).message.replaceAll(",", ",\n"));
        } else {
          toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
        }
      });
  }

  handleClickEmail = () => (ev) => {
    var desc = "Confirma o envio do email para o responsável da financeira";
    if (this.props.fatura.paramsUf && this.props.fatura.paramsUf.lista2) {
      desc += ` com os seguintes documentos: ${this.props.fatura.paramsUf.lista.join(", ")}`;
    }
    this.props.onActionOpen({
      description: `${desc}?`,
      onSuccess: this.handleOnEmail.bind(this),
    });
  };

  handleOnEmail() {
    var props = this.props;
    var dados = {
      idCobranca: this.props.params.slug,
    };
    Promise.resolve(api.Charging.emailCobranca(dados))
      .then((response) => {
        toastr.success("Sucesso", "Email enviado com sucesso");
        //this.props.onListLoad(api.Charging.emailCobranca(dados.idCobranca));
        this.props.onChargingsLoad(api.Charging.get(dados.idCobranca));
      })
      .catch((e) => {
        if (e.message === "Unauthorized" || e.message === "jwt expired") {
          api.Auth.logout();
          props.onLogout();
        } else if (e.response && e.response.text) {
          toastr.info("Aviso", JSON.parse(e.response.text).message);
        } else {
          toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
        }
      });
  }

  handleClickEmail2 = () => (ev) => {
    var desc = "Confirma o envio do email para o responsável da financeira com os seguintes documentos: ";
    desc += `${this.props.fatura.paramsUf.lista2.join(", ")}`;
    this.props.onActionOpen({
      description: `${desc}?`,
      onSuccess: this.handleOnEmail2.bind(this),
    });
  };

  handleOnEmail2() {
    var props = this.props;
    var dados = {
      idCobranca: this.props.params.slug,
    };
    Promise.resolve(api.Charging.emailCobranca2(dados))
      .then((response) => {
        toastr.success("Sucesso", "Email enviado com sucesso");
        //this.props.onListLoad(api.Charging.emailCobranca(dados.idCobranca));
        this.props.onChargingsLoad(api.Charging.get(dados.idCobranca));
      })
      .catch((e) => {
        if (e.message === "Unauthorized" || e.message === "jwt expired") {
          api.Auth.logout();
          props.onLogout();
        } else if (e.response && e.response.text) {
          toastr.info("Aviso", JSON.parse(e.response.text).message);
        } else {
          toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
        }
      });
  }

  handleClickEmitirDUA = () => (ev) => {
    ev.preventDefault();
    this.generateDUAPDF();
  };

  generateDUAPDF = () => {
    try {
      const { fatura } = this.props;
      if (!fatura) {
        toastr.error("Erro", "Dados da fatura não disponíveis para gerar o DUA.");
        return;
      }

      const doc = new jsPDF("p", "mm", "a4");
      const pageWidth = doc.internal.pageSize.width;
      const margin = 10;
      const contentWidth = pageWidth - margin * 2;

      // Header - DUA information (all centered, excluding "Governo do Estado do Espírito Santo")
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text(`DEPARTAMENTO ESTADUAL DE TRÂNSITO - DETRAN/${this.props.fatura.uf}`, pageWidth / 2, 10, { align: "center" });
      doc.setFontSize(10);
      doc.text("DUA - DOCUMENTO ÚNICO DE ARRECADAÇÃO", pageWidth / 2, 15, { align: "center" });

      // Table configuration for main information
      const tableOptions = {
        startY: 20,
        theme: "grid",
        styles: {
          fontSize: 8,
          cellPadding: 1.5,
          valign: "middle",
        },
        headStyles: {
          fillColor: [220, 220, 220],
          textColor: 0,
          fontSize: 7,
          fontStyle: "bold",
          halign: "left",
        },
        bodyStyles: {},
      };

      const dueDate = new Date();
      dueDate.setDate(dueDate.getDate() + 5);
      const formattedDueDate = dueDate.toLocaleDateString("pt-BR");
      const currentDate = new Date().toLocaleDateString("pt-BR");
      const currentTime = new Date().toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
      const currentMonth = (new Date().getMonth() + 1).toString().padStart(2, "0");
      const currentYear = new Date().getFullYear();
      const reference = `${currentMonth}/${currentYear}`;

      // Main table data with proper boleto format
      const body = [
        // Linha 1: Órgão e Vencimento
        [
          { content: "Órgão", colSpan: 3, styles: { fontStyle: "normal", fontSize: 7 } },
          { content: "Vencimento", styles: { halign: "right", fontStyle: "normal", fontSize: 7 } },
        ],
        [
          { content: `Departamento de Trânsito do ${this.props.fatura.uf}`, colSpan: 3, styles: { fontStyle: "bold", fontSize: 8 } },
          { content: formattedDueDate, styles: { halign: "right", fontStyle: "bold", fontSize: 8 } },
        ],
        // Linha 3: Serviço e Valor
        [
          { content: "Serviço", colSpan: 3, styles: { fontStyle: "normal", fontSize: 7 } },
          { content: "Valor", styles: { halign: "right", fontStyle: "normal", fontSize: 7 } },
        ],
        [
          { content: "Taxa Referente ao Serviço de Registro Contrato", colSpan: 3, styles: { fontStyle: "bold", fontSize: 8 } },
          { content: fatura.valorTotal ? MaskDecimal.TO_BRL(fatura.valorTotal) : "R$ 0,00", styles: { halign: "right", fontStyle: "bold", fontSize: 8 } },
        ],
        //
        [
          { content: "Pagador", colSpan: 2, styles: { fontStyle: "normal", fontSize: 7 } },
          { content: "Total de Registros", styles: { fontStyle: "normal", fontSize: 7 } },
          { content: "Juros", styles: { halign: "right", fontStyle: "normal", fontSize: 7 } },
        ],
        [
          { content: fatura.razaoSocial, colSpan: 2, styles: { fontStyle: "bold", fontSize: 8 } },
          { content: this.props.fatura.quantidade, styles: { halign: "center", fontStyle: "bold", fontSize: 8 } },
          { content: "* * * * * * * * * *", styles: { halign: "right", fontStyle: "bold", fontSize: 8 } },
        ],
        // Linha 4: Data Emissão, Hora, Referência, Multa (A SUA SOLICITAÇÃO)
        [
          { content: "Data da Emissão", styles: { fontStyle: "normal", fontSize: 7 } },
          { content: "Hora da Emissão", styles: { fontStyle: "normal", fontSize: 7 } },
          { content: "Referência", styles: { fontStyle: "normal", fontSize: 7 } },
          { content: "Multa", styles: { halign: "right", fontStyle: "normal", fontSize: 7 } },
        ],
        [
          { content: currentDate, styles: { halign: "center", fontStyle: "bold", fontSize: 8 } },
          { content: currentTime, styles: { halign: "center", fontStyle: "bold", fontSize: 8 } },
          { content: reference, styles: { halign: "center", fontStyle: "bold", fontSize: 8 } },
          { content: "* * * * * * * * * *", styles: { halign: "right", fontStyle: "bold", fontSize: 8 } },
        ],
        // Linha 5: Data Documento e Nº Documento
        [
          { content: "Data do Processamento", styles: { fontStyle: "normal", fontSize: 7 } },
          { content: "Nº do Documento", styles: { fontStyle: "normal", fontSize: 7 } },
          { content: "Nosso Número", styles: { fontStyle: "normal", fontSize: 7 } },
          { content: "(-) Crédito", styles: { fontStyle: "normal", fontSize: 7 } },
        ],
        [
          { content: currentDate, styles: { halign: "center", fontStyle: "bold", fontSize: 8 } },
          { content: fatura.id ? fatura.id.toString().padStart(10, "0") : "0000000000", styles: { halign: "center", fontStyle: "bold", fontSize: 8 } },
          { content: `27650${fatura.id ? fatura.id.toString().padStart(8, "0") : "00000000"}`, styles: { halign: "center", fontStyle: "bold", fontSize: 8 } },
          { content: "* * * * * * * * * *", styles: { halign: "right", fontStyle: "bold", fontSize: 8 } },
        ],
        [
          {
            content: `Pagar até ${formattedDueDate} com o valor de ${
              fatura.valorTotal ? MaskDecimal.TO_BRL(fatura.valorTotal) : "R$ 0,00"
            }. Após o vencimento, multa de 2% + juros de 1% ao mês.\nPagável em qualquer banco ou casa lotérica. Não receber após 30 dias do vencimento.\nReferente a: Taxa de Serviço de Registro Contrato`,
            rowSpan: 3,
            colSpan: 3,
            styles: { fontStyle: "normal", fontSize: 7, valign: "top" },
          },
          { content: "(=) Valor Documento", styles: { halign: "right", fontStyle: "normal", fontSize: 7, valign: "bottom" } },
        ],
        [{ content: fatura.valorTotal ? MaskDecimal.TO_BRL(fatura.valorTotal) : "R$ 0,00", styles: { halign: "right", fontStyle: "bold", fontSize: 8 } }],
        // [], // Linha vazia para acomodar o rowspan aumentado
      ];

      doc.autoTable({
        ...tableOptions,
        columnStyles: {
          0: { cellWidth: contentWidth * 0.25 },
          1: { cellWidth: contentWidth * 0.25 },
          2: { cellWidth: contentWidth * 0.25 },
          3: { cellWidth: contentWidth * 0.25, halign: "right" },
        },
        body: body,
        didDrawPage: (data) => {
          let finalY = data.cursor.y + 5;

          // Barcode section
          const linhaDigitavel = "85890.12345 56789.012345 67890.123456 7 89010000050123"; // Simulated
          const img = new Image();
          img.src = barcodeImage;

          doc.setFontSize(10);
          doc.setFont("helvetica", "bold");
          doc.text(linhaDigitavel, pageWidth / 2, finalY, { align: "center" });
          finalY += 1; // Reduz o espaço entre o número e a imagem
          const barcodeWidth = 80; // Largura do código de barras em mm
          const barcodeX = (pageWidth - barcodeWidth) / 2; // Posição X para centralizar
          doc.addImage(img, "PNG", barcodeX, finalY, barcodeWidth, 30);
          finalY += 22; // Ajusta o espaço após a imagem com a nova altura

          // Linha de corte
          const cutLineY = finalY + 5;
          doc.setLineDash([1, 1]);
          doc.line(margin, cutLineY, pageWidth - margin, cutLineY);
          doc.setLineDash([]);
          doc.setFontSize(8);
          doc.setFontSize(7);
          doc.text("Corte na linha pontilhada", margin, cutLineY - 2);
          doc.text("Autenticação Mecânica", pageWidth - margin - 30, cutLineY - 2);

          // Recibo do Pagador
          let reciboY = cutLineY + 5;
          doc.setFontSize(10);
          doc.setFont("helvetica", "bold");
          doc.text("Recibo do Pagador", pageWidth / 2, reciboY, { align: "center" });
          reciboY += 8;
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");
          doc.text(`Beneficiário: DETRAN/${this.props.fatura.uf} - CNPJ: 65.603.582/2285-97`, margin, reciboY);
          doc.text(`Vencimento: ${formattedDueDate}`, pageWidth - margin, reciboY, { align: "right" });
          reciboY += 4;
          doc.text(`Pagador: ${fatura.razaoSocial || "NÃO INFORMADO"}`, margin, reciboY);
          doc.text(`Valor: ${fatura.valorTotal ? MaskDecimal.TO_BRL(fatura.valorTotal) : "R$ 0,00"}`, pageWidth - margin, reciboY, { align: "right" });
          reciboY += 6;
          doc.text(`Documento: ${fatura.id ? fatura.id.toString().padStart(10, "0") : "0000000000"}`, margin, reciboY);
        },
      });

      // Salva o PDF
      const fileName = `DUA_${fatura.id || "documento"}_${currentDate.replace(/\//g, "-")}.pdf`;
      doc.save(fileName);

      toastr.success("Sucesso", "DUA gerado com sucesso!");
    } catch (error) {
      console.error("Erro ao gerar DUA:", error);
      toastr.error("Erro", "Ocorreu um erro ao gerar o DUA. Verifique o console para mais detalhes.");
    }
  };

  render() {
    return (
      <div>
        <Title routes={this.props.routes} params={this.props.params} description="Gestão Financeira" />
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="hpanel">
                <div className="panel-heading">
                  <div className="panel-tools">
                    {_.findIndex(this.props.currentUser.perfis, function (perfil) {
                      return perfil === "ALIAS";
                    }) === -1 && (
                      <span>
                        {this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "DAE_DARE").length > 0 && (
                          <Link className="btn btn-default" onClick={this.handleClickDownload("DAE_DARE")}>
                            <i className="fas fa-download" /> DAE/DARE
                          </Link>
                        )}
                        {this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "OFICIO_COBRANCA").length > 0 && (
                          <Link className="btn btn-default" onClick={this.handleClickDownload("OFICIO_COBRANCA")}>
                            <i className="fas fa-download" /> Ofício Cobrança
                          </Link>
                        )}
                        {this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "RELATORIO").length > 0 && (
                          <Link className="btn btn-default" onClick={this.handleClickDownload("RELATORIO")}>
                            <i className="fas fa-download" /> Relatório
                          </Link>
                        )}
                        {/* {this.props.fatura && this.props.fatura.uf === "SC" && <span class="linha-vertical"></span>} */}

                        {this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "DAE_DARE2").length > 0 && (
                          <Link className="btn btn-default" onClick={this.handleClickDownload("DAE_DARE2")}>
                            <i className="fas fa-download" /> DAE/DARE 2
                          </Link>
                        )}
                        {this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "RELATORIO2").length > 0 && (
                          <Link className="btn btn-default" onClick={this.handleClickDownload("RELATORIO2")}>
                            <i className="fas fa-download" /> Relatório 2
                          </Link>
                        )}
                        {this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "NFE").length > 0 && (
                          <Link className="btn btn-default" onClick={this.handleClickDownload("NFE")}>
                            <i className="fas fa-download" /> NFe
                          </Link>
                        )}
                        {this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "BOLETO_NFE").length > 0 && (
                          <Link className="btn btn-default" onClick={this.handleClickDownload("BOLETO_NFE")}>
                            <i className="fas fa-download" /> Boleto NFe
                          </Link>
                        )}
                        {this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "NOTA_DEBITO").length > 0 && (
                          <Link className="btn btn-default" onClick={this.handleClickDownload("NOTA_DEBITO")}>
                            <i className="fas fa-download" /> Nt. Débito
                          </Link>
                        )}
                        {this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "BOLETO_ND").length > 0 && (
                          <Link className="btn btn-default" onClick={this.handleClickDownload("BOLETO_ND")}>
                            <i className="fas fa-download" /> Boleto Nt. Débito
                          </Link>
                        )}
                      </span>
                    )}
                    {_.findIndex(this.props.currentUser.perfis, function (perfil) {
                      return perfil === "ALIAS";
                    }) > -1 && (
                      <span>
                        <div class="dropdown">
                          <button class={this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "DAE_DARE").length > 0 ? "btn-success btn" : "btn btn-default"}>DAE/DARE</button>
                          <div class="dropdown-content">
                            <Dropzone
                              accept="application/pdf"
                              name="file"
                              className="dropzone-blank fallback"
                              multiple={false}
                              onDrop={(filesToUpload, e) => this.handleClickUpload(filesToUpload, "DAE_DARE")}
                            >
                              <Link className="btn btn-xs">
                                <i className="fas fa-upload" /> Anexar
                              </Link>
                            </Dropzone>
                            {this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "DAE_DARE").length > 0 && (
                              <Link className="btn btn-xs" onClick={this.handleClickDownload("DAE_DARE")}>
                                <i className="fas fa-download" /> Baixar
                              </Link>
                            )}
                          </div>
                        </div>
                        <div class="dropdown">
                          <button class={this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "OFICIO_COBRANCA").length > 0 ? "btn-success btn" : "btn btn-default"}>
                            Ofício Cobrança
                          </button>
                          <div class="dropdown-content">
                            <Dropzone
                              accept="application/pdf"
                              name="file"
                              className="dropzone-blank fallback"
                              multiple={false}
                              onDrop={(filesToUpload, e) => this.handleClickUpload(filesToUpload, "OFICIO_COBRANCA")}
                            >
                              <Link className="btn btn-xs">
                                <i className="fas fa-upload" /> Anexar
                              </Link>
                            </Dropzone>
                            {this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "OFICIO_COBRANCA").length > 0 && (
                              <Link className="btn btn-xs" onClick={this.handleClickDownload("OFICIO_COBRANCA")}>
                                <i className="fas fa-download" /> Baixar
                              </Link>
                            )}
                          </div>
                        </div>
                        <div class="dropdown">
                          <button class={this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "RELATORIO").length > 0 ? "btn-success btn" : "btn btn-default"}>Relatório</button>
                          <div class="dropdown-content">
                            <Dropzone
                              accept="application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                              name="file"
                              className="dropzone-blank fallback"
                              multiple={false}
                              onDrop={(filesToUpload, e) => this.handleClickUpload(filesToUpload, "RELATORIO")}
                            >
                              <Link className="btn btn-xs">
                                <i className="fas fa-upload" /> Anexar
                              </Link>
                            </Dropzone>
                            {this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "RELATORIO").length > 0 && (
                              <Link className="btn btn-xs" onClick={this.handleClickDownload("RELATORIO")}>
                                <i className="fas fa-download" /> Baixar
                              </Link>
                            )}
                          </div>
                        </div>
                        {/* {this.props.fatura && this.props.fatura.uf === "SC" && (
                          <span>
                            {this.props.fatura.status === 3 && (
                              <Link className="btn btn-success" onClick={this.handleClickEmail()}>
                                E-mail 1
                              </Link>
                            )}
                            <span class="linha-vertical"></span>
                            <div class="dropdown">
                              <button class={this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "DAE_DARE2").length > 0 ? "btn-success btn" : "btn btn-default"}>
                                DAE/DARE 2
                              </button>
                              <div class="dropdown-content">
                                <Dropzone
                                  accept="application/pdf"
                                  name="file"
                                  className="dropzone-blank fallback"
                                  multiple={false}
                                  onDrop={(filesToUpload, e) => this.handleClickUpload(filesToUpload, "DAE_DARE2")}
                                >
                                  <Link className="btn btn-xs">
                                    <i className="fas fa-upload" /> Anexar
                                  </Link>
                                </Dropzone>
                                {this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "DAE_DARE2").length > 0 && (
                                  <Link className="btn btn-xs" onClick={this.handleClickDownload("DAE_DARE2")}>
                                    <i className="fas fa-download" /> Baixar
                                  </Link>
                                )}
                              </div>
                            </div>
                            <div class="dropdown">
                              <button class={this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "RELATORIO2").length > 0 ? "btn-success btn" : "btn btn-default"}>
                                Relatório 2
                              </button>
                              <div class="dropdown-content">
                                <Dropzone
                                  accept="application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                  name="file"
                                  className="dropzone-blank fallback"
                                  multiple={false}
                                  onDrop={(filesToUpload, e) => this.handleClickUpload(filesToUpload, "RELATORIO2")}
                                >
                                  <Link className="btn btn-xs">
                                    <i className="fas fa-upload" /> Anexar
                                  </Link>
                                </Dropzone>
                                {this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "RELATORIO2").length > 0 && (
                                  <Link className="btn btn-xs" onClick={this.handleClickDownload("RELATORIO2")}>
                                    <i className="fas fa-download" /> Baixar
                                  </Link>
                                )}
                              </div>
                            </div>
                          </span>
                        )} */}

                        <div class="dropdown">
                          <button class={this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "NFE").length > 0 ? "btn-success btn" : "btn btn-default"}>NFe</button>
                          <div class="dropdown-content">
                            <Dropzone
                              accept="application/pdf"
                              name="file"
                              className="dropzone-blank fallback"
                              multiple={false}
                              onDrop={(filesToUpload, e) => this.handleClickUpload(filesToUpload, "NFE")}
                            >
                              <Link className="btn btn-xs">
                                <i className="fas fa-upload" /> Anexar
                              </Link>
                            </Dropzone>
                            {this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "NFE").length > 0 && (
                              <Link className="btn btn-xs" onClick={this.handleClickDownload("NFE")}>
                                <i className="fas fa-download" /> Baixar
                              </Link>
                            )}
                          </div>
                        </div>
                        <div class="dropdown">
                          <button class={this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "BOLETO_NFE").length > 0 ? "btn-success btn" : "btn btn-default"}>Boleto NFe</button>
                          <div class="dropdown-content">
                            <Dropzone
                              accept="application/pdf"
                              name="file"
                              className="dropzone-blank fallback"
                              multiple={false}
                              onDrop={(filesToUpload, e) => this.handleClickUpload(filesToUpload, "BOLETO_NFE")}
                            >
                              <Link className="btn btn-xs">
                                <i className="fas fa-upload" /> Anexar
                              </Link>
                            </Dropzone>
                            {this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "BOLETO_NFE").length > 0 && (
                              <Link className="btn btn-xs" onClick={this.handleClickDownload("BOLETO_NFE")}>
                                <i className="fas fa-download" /> Baixar
                              </Link>
                            )}
                          </div>
                        </div>
                        <div class="dropdown">
                          <button class={this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "NOTA_DEBITO").length > 0 ? "btn-success btn" : "btn btn-default"}>Nt. Débito</button>
                          <div class="dropdown-content">
                            <Dropzone
                              accept="application/pdf"
                              name="file"
                              className="dropzone-blank fallback"
                              multiple={false}
                              onDrop={(filesToUpload, e) => this.handleClickUpload(filesToUpload, "NOTA_DEBITO")}
                            >
                              <Link className="btn btn-xs">
                                <i className="fas fa-upload" /> Anexar
                              </Link>
                            </Dropzone>
                            {this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "NOTA_DEBITO").length > 0 && (
                              <Link className="btn btn-xs" onClick={this.handleClickDownload("NOTA_DEBITO")}>
                                <i className="fas fa-download" /> Baixar
                              </Link>
                            )}
                          </div>
                        </div>
                        <div class="dropdown">
                          <button class={this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "BOLETO_ND").length > 0 ? "btn-success btn" : "btn btn-default"}>
                            Boleto Nt. Débito
                          </button>
                          <div class="dropdown-content">
                            <Dropzone
                              accept="application/pdf"
                              name="file"
                              className="dropzone-blank fallback"
                              multiple={false}
                              onDrop={(filesToUpload, e) => this.handleClickUpload(filesToUpload, "BOLETO_ND")}
                            >
                              <Link className="btn btn-xs">
                                <i className="fas fa-upload" /> Anexar
                              </Link>
                            </Dropzone>
                            {this.props.tipoAnexos && this.props.tipoAnexos.filter((a) => a.tipo === "BOLETO_ND").length > 0 && (
                              <Link className="btn btn-xs" onClick={this.handleClickDownload("BOLETO_ND")}>
                                <i className="fas fa-download" /> Baixar
                              </Link>
                            )}
                          </div>
                        </div>
                      </span>
                    )}
                    {_.findIndex(this.props.currentUser.perfis, function (perfil) {
                      return perfil === "ALIAS";
                    }) > -1 && (
                      <span>
                        {this.props.fatura && this.props.fatura.status === 1 && (
                          <Link className="btn btn-success" onClick={this.handleClickClose()}>
                            Fechar
                          </Link>
                        )}
                        {this.props.fatura && this.props.fatura.status === 3 && (
                          <>
                            <Link className="btn btn-success" onClick={this.handleClickEmail()}>
                              E-mail
                            </Link>
                            {/* <Link className="btn btn-primary" onClick={this.handleClickEmitirDUA()}>
                              Emitir DUA
                            </Link> */}
                          </>
                        )}

                        {/* <Link className="btn btn-success" onClick={this.handleClickEmail2()}>
                          E-mail 2
                        </Link> */}
                      </span>
                    )}
                    <Link className="btn btn-info" onClick={browserHistory.goBack}>
                      {" "}
                      Voltar
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="hpanel">
                <div className="panel-heading">Dados consolidados da fatura</div>
                <div className="panel-body">
                  <div className="row">
                    <div className="col-md-12 text-center">
                      <div className="small">
                        <i className="fa fa-bolt"></i> Total de registros
                      </div>
                      <div>
                        <h1 className="font-extra-bold m-t-xl m-b-xs">{this.props.fatura ? this.props.fatura.quantidade : 0}</h1>
                        <small>Registros / Averbações</small>
                      </div>
                      <div className=" m-t-xl">
                        <i className="fas fa-clock"></i> Período: {this.props.fatura ? MaskDate.TO_BR(this.props.fatura.periodoInicio) + " a " + MaskDate.TO_BR(this.props.fatura.periodoFim) : ""}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="hpanel">
                <div className="panel-heading">&nbsp;</div>
                <div className="panel-body">
                  <div className="row">
                    <div className="col-md-12 text-center">
                      <div className="small">
                        <i className="fas fa-dollar-sign"></i> Valor total
                      </div>
                      <div>
                        <h1 className="font-extra-bold m-t-xl m-b-xs">{this.props.fatura ? MaskDecimal.TO_BRL(this.props.fatura.valorTotal) : 0}</h1>
                        <small>
                          Status:{" "}
                          {this.props.fatura ? (this.props.fatura.status === 1 ? "ABERTO" : this.props.fatura.status === 2 ? "PAGO" : this.props.fatura.status === 3 ? "FECHADO" : "Outro") : ""}
                        </small>
                      </div>
                      <div className=" m-t-xl">Financeira: {this.props.fatura ? this.props.fatura.razaoSocial : ""}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="hpanel">
                <div className="panel-body">
                  <p>
                    <strong>Registros</strong>
                  </p>
                  <div className="table-responsive">
                    <ReactTable
                      className="-striped -highlight"
                      data={this.props.registrosFatura}
                      previousText="Anterior"
                      nextText="Próximo"
                      loadingText="Carregando..."
                      noDataText="Nenhum registro encontrado"
                      pageText="página"
                      ofText="de"
                      rowsText="linhas"
                      columns={columns}
                      defaultPageSize={10}
                      showPageSizeOptions={false}
                      minRows={1}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  onListLoad: (payload) => dispatch({ type: INVOICE_DETAIL_INVOICES_LOAD, payload }),
  onChargingsLoad: (payload) => dispatch({ type: INVOICE_DETAIL_CHARGING_LOAD, payload }),
  onLogout: () => dispatch({ type: LOGOUT }),
  onListAnexos: (payload) => dispatch({ type: INVOICE_ANEXOS_LIST_LOAD, payload }),
  onActionOpen: (payload) => dispatch({ type: CONFIRM_ACTION_OPEN, payload }),
});

const mapStateToProps = (state) => ({
  ...state.invoice,
  currentUser: state.common.currentUser,
});

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceDetails);
